export default "__VITE_ASSET__ae9139ee__"